module.exports = __webpack_public_path__ + "static/media/bonanza_megaways.btg.4c536f06.jpeg";